/**
 * Subscription Plan master-specific translation keys
 */
export const subscriptionPlan = {
  list: {
    search_placeholder: "admin.subscription_plan_search_placeholder",
    main_heading: "admin.subscription_plan_list_heading",
    create_btn_text: "admin.subscription_plan_create_btn_text",
    table: {
      name_col_heading: "admin.subscription_plan_name_table_col_heading",
      user_type_col_heading: "admin.subscription_plan_user_type_table_col_heading",
      product_ids_col_heading: "admin.subscription_plan_product_ids_table_col_heading",
      status_col_heading: "admin.subscription_plan_status_table_col_heading",
      created_at_col_heading: "admin.subscription_plan_created_at_table_col_heading",
      action_col_heading: "admin.subscription_plan_action_table_col_heading",
    },
    status: {
      active: "admin.subscription_plan_status_active",
      inactive: "admin.subscription_plan_status_inactive",
    },
    status_filter_options: {
      all: "admin.subscription_plan_status_filter_all",
      active: "admin.subscription_plan_status_filter_active",
      inactive: "admin.subscription_plan_status_filter_inactive",
    },
    user_type_filter_options: {
      all: "admin.subscription_plan_user_type_filter_all",
      normal_user: "admin.subscription_plan_user_type_filter_normal_user",
      freelancer_user: "admin.subscription_plan_user_type_filter_freelancer_user",
    },
    apple_product_id_prefix: "admin.subscription_plan_apple_product_id_prefix",
    google_product_id_prefix: "admin.subscription_plan_google_product_id_prefix",
    defaults: {
      na: "admin.subscription_plan_list_defaults_na",
    },
    delete_popup_heading_text: "admin.subscription_plan_delete_popup_heading_text",
    delete_popup_message_text: "admin.subscription_plan_delete_popup_message_text",
    delete_popup_yes_btn_text: "admin.subscription_plan_delete_popup_yes_btn_text",
    delete_popup_no_btn_text: "admin.subscription_plan_delete_popup_no_btn_text",
    status_popup_heading_text: "admin.subscription_plan_status_popup_heading_text",
    status_popup_yes_btn_text: "admin.subscription_plan_status_popup_yes_btn_text",
    status_popup_no_btn_text: "admin.subscription_plan_status_popup_no_btn_text",
    clear_filter_btn_text: "admin.subscription_plan_clear_filter_btn_text",
  },
  add: {
    main_heading: "admin.subscription_plan_add_heading",
  },
  edit: {
    main_heading: "admin.subscription_plan_edit_heading",
  },
  form: {
    name_label: "admin.subscription_plan_name_label",
    name_placeholder: "admin.subscription_plan_name_placeholder",
    user_type_label: "admin.subscription_plan_user_type_label",
    user_type_placeholder: "admin.subscription_plan_user_type_placeholder",
    user_type_options: {
      normal_user: "admin.subscription_plan_user_type_option_normal_user",
      freelancer_user: "admin.subscription_plan_user_type_option_freelancer_user",
    },
    duration_label: "admin.subscription_plan_duration_label",
    duration_placeholder: "admin.subscription_plan_duration_placeholder",
    duration_options: {
      weekly: "admin.subscription_plan_duration_option_weekly",
      monthly: "admin.subscription_plan_duration_option_monthly",
      quarterly: "admin.subscription_plan_duration_option_quarterly",
      semiannually: "admin.subscription_plan_duration_option_semiannually",
      annually: "admin.subscription_plan_duration_option_annually",
    },
    apple_product_id_label: "admin.subscription_plan_apple_product_id_label",
    apple_product_id_placeholder: "admin.subscription_plan_apple_product_id_placeholder",
    google_product_id_label: "admin.subscription_plan_google_product_id_label",
    google_product_id_placeholder: "admin.subscription_plan_google_product_id_placeholder",
    submit_btn_text: "admin.subscription_plan_submit_btn_text",
    update_btn_text: "admin.subscription_plan_update_btn_text",
    cancel_btn_text: "admin.subscription_plan_cancel_btn_text",
    loading_btn_text: "admin.subscription_plan_loading_btn_text",
  },
  user_type: {
    normal_user: "admin.subscription_plan_user_type_normal_user",
    freelancer_user: "admin.subscription_plan_user_type_freelancer_user",
  },
};
